import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";
const user = JSON.parse(localStorage.getItem("user_data")) || {}
// const userId = user?.user_id;
const accountType = user?.account_type;
const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  holyLoading: false,
  holySuccess: false,
  holyError: false,
  holyMessage: null,

  holyGetLoading: false,
  holyGetSuccess: false,
  holyGetError: false,
  holyGetMessage: null,
  holyGetData: null,

  fetchHolyLoading: false,
  fetchHolySuccess: false,
  fetchHolyError: false,
  fetchHolyMessage: null,
  fetchHolyData: null,
};

export const fetchData = createAsyncThunk("fetchData", async (userId) => {
  return await axios
    .get(`${baseUrl}admin/getMyHolidayList?userId=${userId}`, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
          data: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
        };
        return data;
      } else {
        return error;
      }
    });
});

export const fetchHolidayData = createAsyncThunk("fetchHolidayData", async (path) => {
  return await axios
    .get(`${baseUrl}${path}`, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
          data: {
            data: [],
            message: "No Internet Connection Found",
            success: false,
          },
        };
        return data;
      } else {
        return error;
      }
    });
});

export const saveHoliday = createAsyncThunk("saveHoliday", async (data) => {
  const result = {
    data: {
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };
  return parseInt(accountType) === 2
    ? result
    : await axios
      .post(`${baseUrl}admin/createMyHoliday`, data, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
});

const holidaySlice = createSlice({
  name: "holiday",
  initialState,

  reducers: {

    initFetchHolidayState: (state) => {
      state.fetchHolyLoading = false;
      state.fetchHolySuccess = false;
      state.fetchHolyError = false;
      state.fetchHolyMessage = null;
      state.fetchHolyData = null;
    }

  },

  extraReducers: (builder) => {
    builder.addCase(fetchData.pending, (state, action) => {
      state.holyGetLoading = true;
      state.holyGetSuccess = false;
      state.holyGetError = false;
      state.holyGetMessage = null;
      state.holyGetData = null;
    });
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.holyGetLoading = false;
      state.holyGetSuccess = true;
      state.holyGetError = false;
      state.holyGetMessage = action.payload.status == 200 ? action.payload.data.message : action.payload.response.data.message;
      state.holyGetData = action.payload.status == 200 ? action.payload.data.data : [];
    });
    builder.addCase(fetchData.rejected, (state, action) => {
      state.holyGetLoading = false;
      state.holyGetSuccess = false;
      state.holyGetError = true;
      state.holyGetMessage = action.payload.data.message;
      state.holyGetData = null;
    });
    // To create holiday ------------------------------------
    builder.addCase(saveHoliday.pending, (state, action) => {
      state.holyLoading = true;
      state.holySuccess = false;
      state.holyError = false;
      state.holyMessage = null;
    });
    builder.addCase(saveHoliday.fulfilled, (state, action) => {
      state.holyLoading = false;
      state.holySuccess = accountType == 2 ? false : true;
      state.holyError = accountType == 2 ? true : false;
      state.holyMessage = action.payload.data.message;
    });
    builder.addCase(saveHoliday.rejected, (state, action) => {
      state.holyLoading = false;
      state.holySuccess = false;
      state.holyError = true;
      state.holyMessage = action.payload.data.message;
    });
    // ----------------------------------------------------------
    // -----------------------------------------

    builder.addCase(fetchHolidayData.pending, (state, action) => {
      state.fetchHolyLoading = true;
      state.fetchHolySuccess = false;
      state.fetchHolyError = false;
      state.fetchHolyMessage = null;
      state.fetchHolyData = null;
    });

    builder.addCase(fetchHolidayData.fulfilled, (state, action) => {
      const status = action.payload.status;
      if (status == 200 || status == "200") {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.fetchHolyLoading = false;
          state.fetchHolySuccess = true;
          state.fetchHolyError = false;
          state.fetchHolyMessage = action.payload.data.message;
          state.fetchHolyData = action.payload.data.data;
        } else {
          state.fetchHolyLoading = false;
          state.fetchHolySuccess = false;
          state.fetchHolyError = true;
          state.fetchHolyMessage = action.payload.data.message
            ? action.payload.data.message
            : action.payload.data.msg;
          state.fetchHolyData = null;
        }
      } else {
        state.fetchHolyLoading = false;
        state.fetchHolySuccess = false;
        state.fetchHolyError = true;
        state.fetchHolyMessage = action.payload.response.data.message;
        state.fetchHolyData = action.payload.response.data.data;
      }
    });

    builder.addCase(fetchHolidayData.rejected, (state, action) => {
      state.fetchHolyLoading = false;
      state.fetchHolySuccess = true;
      state.fetchHolyError = false;
      state.fetchHolyMessage = null;
      state.fetchHolyData = null;
    });
  },
});
export const { initFetchHolidayState } = holidaySlice.actions;

export default holidaySlice.reducer;
